module.exports = {"530621101":"文屏镇","530621102":"水磨镇","530621103":"龙头山镇","530621104":"小寨镇","530621105":"江底镇","530621106":"火德红镇","530621107":"龙树镇","530621108":"新街镇","530621109":"梭山镇","530621110":"乐红镇","530621201":"桃源回族乡","530621202":"茨院回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530621.json
// module id = 2580
// module chunks = 0